export const getOptionValueNumber = value => parseFloat(value) || '';
export const getOptionLabelNumber = value => parseFloat(value) || 0;

export const getOptionValueInteger = value => parseInt(value) || '';
export const getOptionLabelInteger = value => parseInt(value) || 0;

export const getOptionIdentity = value => value;
